import { render, staticRenderFns } from "./CasinoInfoView.vue?vue&type=template&id=8e05cd22&scoped=true"
import script from "./CasinoInfoView.vue?vue&type=script&lang=js"
export * from "./CasinoInfoView.vue?vue&type=script&lang=js"
import style0 from "./CasinoInfoView.vue?vue&type=style&index=0&id=8e05cd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e05cd22",
  null
  
)

export default component.exports